<template>
  <v-row>
    <v-col cols="12">
      <v-form ref="crudForm" @submit.prevent="submit">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field label="Country Code"
                          maxlength="2"
                          v-model="model.Code"
                          v-mask="masks.code"
                          :rules="rules.Code" />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field label="3-Letter Code"
                          maxlength="3"
                          v-model="model.CodeLong"
                          v-mask="masks.codeLong"
                          :rules="rules.CodeLong" />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field class="no-spinner"
                          label="Country Number"
                          type="number"
                          v-model="model.Number" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field label="Country Name"
                          v-model="model.Title"
                          :rules="rules.Title" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn type="submit" color="primary" :loading="loading">
              {{ id ? 'Save' : 'Create' }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mask } from 'vue-the-mask';
import FormMixins from '@/components/Mixins/Forms';
import { rules } from '@/util/Helpers';

export default {
  name: 'CountryForm',
  directives: {
    mask,
  },
  mixins: [FormMixins],
  props: {
    Id: [String, Number],
    Title: String,
    Code: String,
    CodeLong: String,
    Number: String,
  },
  data() {
    return {
      id: this.Id,
      model: {
        Title: this.Title,
        Code: this.Code,
        CodeLong: this.CodeLong,
        Number: this.Number,
      },
      rules: {
        Title: [
          (v) => rules.required(v, 'Please enter a Country Name'),
        ],
        Code: [
          (v) => rules.required(v, 'Please enter a Country Code'),
          (v) => rules.length(v || '', 2, 'Code must be 2 characters in length', true),
        ],
        CodeLong: [
          (v) => rules.required(v, 'Please enter a Country Code'),
          (v) => rules.length(v || '', 3, 'Code must be 3 characters in length', true),
        ],
      },
      masks: {
        code: 'AA',
        codeLong: 'AAA',
      },
      loading: false,
    };
  },
  methods: {
    submit() {
      if (this.$refs.crudForm.validate()) {
        this.loading = true;
        if (this.id) {
          this.update();
        } else {
          this.create();
        }
        this.loading = false;
      } else {
        this.$refs.crudForm.inputs.every(this.goToFirstError);
      }
    },
    async create() {
      try {
        const response = await this.$store.dispatch('post', {
          api: 'Country',
          data: this.model,
        });
        this.$emit('snackbar', 'Country successfully created!');
        this.$emit('crud:create', response);
        this.$emit('crud:success', response);
        this.id = response.data.Id;
      } catch (e) {
        this.$emit('crud:error', e);
      }
    },
    async update() {
      try {
        const response = await this.$store.dispatch('put', {
          api: `Country/${this.model.Code}`,
          data: this.model,
        });
        this.$emit('snackbar', 'Country successfully updated!');
        this.$emit('crud:update', response);
        this.$emit('crud:success', response);
      } catch (e) {
        this.$emit('crud:error', e);
      }
    },
  },
};
</script>
